import { render } from "./AgencyRate.vue?vue&type=template&id=74db8a3c"
import script from "./AgencyRate.vue?vue&type=script&lang=js"
export * from "./AgencyRate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__